import http from './http'

const programaService = {
  getAll: () => http.get(`/programas`).then(result => result.data)
}
export default programaService
